import type { GsmRuleCreateRequest, GsmRuleResponse, GsmRuleUpdateRequest } from '../types';
import type { RequestFn } from '../../client';

export class Gsm {
  constructor(private readonly request: RequestFn) {}

  async create(params: GsmRuleCreateRequest): Promise<GsmRuleResponse> {
    return this.request('POST', '/gsm', { body: params });
  }

  async retrieve(params: Record<string, unknown>): Promise<GsmRuleResponse> {
    return this.request('POST', '/gsm/get', { body: params });
  }

  async update(params: GsmRuleUpdateRequest): Promise<GsmRuleResponse> {
    return this.request('POST', '/gsm/update', { body: params });
  }

  async delete(params: Record<string, unknown>): Promise<GsmRuleResponse> {
    return this.request('POST', '/gsm/delete', { body: params });
  }
}
